module.exports = __webpack_public_path__ + "img/trenholm-state-logo.65508db9.jpg";